import { c as checkThemeContract, m as merge, b as buildBaseTheme, g as getStaticAssetUrl, e as extendsType, a as BASE_TOKENS, d as curriedTransparentize$1, F as FontLoaderFonts, f as BASE_FONTS, h as buildTypographyVariants, i as BASE_COLOR_SCALES$5 } from "./purpleTheme-CUaQ2Ptp.mjs";
const brandBlue = "#0047BB";
const formBlue = "#8CC8E9";
const linkBlue = "#1F74DB";
const mint = "#6ECEB2";
const BASE_COLOR_SCALES$4 = {
  neutral: {
    0: "#FFFFFF",
    50: "#FAFAFA",
    100: "#F8F8F8",
    200: "#F3F3F3",
    300: "#E8E8E8",
    400: "#D1D1D1",
    500: "#BBBBBB",
    600: "#9B9B9B",
    700: "#6E6E6E",
    800: "#464646",
    900: "#282624"
  },
  red: {
    50: "#FEF6F6",
    100: "#FCE4E3",
    150: "#FFEBEA",
    200: "#F6BCB6",
    300: "#F09D94",
    400: "#E87F73",
    500: "#CB1D15",
    600: "#B71A13",
    700: "#A21711",
    800: "#8D140E",
    900: "#78110C"
  },
  green: {
    50: "#EDF8F4",
    100: "#D1E8DF",
    150: "#EAF7F3",
    200: "#ADCFC2",
    300: "#5FAE91",
    400: "#169269",
    500: "#13805C",
    600: "#106A4C",
    700: "#0C543C",
    800: "#093D2C",
    900: "#06271C"
  },
  yellow: {
    50: "#FDF9F6",
    100: "#FFF9EE",
    150: "#FFF3E2",
    200: "#FFECC7",
    300: "#FFDEA0",
    400: "#FFC453",
    500: "#DDA63E",
    600: "#BB8A2C",
    700: "#996E1D",
    800: "#775411",
    900: "#553B09"
  },
  blue: {
    50: "#F5F7F7",
    100: "#E9F0F1",
    200: "#D5EBEF",
    300: "#B2E3EC",
    400: "#7DD9E8",
    500: "#39B2C6",
    600: "#238C9D",
    700: "#177482",
    800: "#0C5561",
    900: "#0B3541"
  }
};
const nationwideBaseColors = {
  ...BASE_COLOR_SCALES$4,
  brandBlue: {
    50: "#E6EDF8",
    100: "#CCDAF1",
    200: "#99B5E4",
    300: "#6691D6",
    400: "#336CC9",
    500: brandBlue,
    // Main color of this group
    600: "#0040A8",
    700: "#003283",
    800: "#002B70",
    900: "#001C4B"
  },
  formBlue: {
    50: "#E8F4FB",
    100: "#DAEEF8",
    200: "#D1E9F6",
    300: "#BADEF2",
    400: "#A3D3ED",
    500: formBlue,
    // Main color of this group
    600: "#7EB4D2",
    700: "#628CA3",
    800: "#466475",
    900: "#2A3C46"
  },
  linkBlue: {
    50: "#E9F1FB",
    100: "#D2E3F8",
    200: "#A5C7F1",
    300: "#79ACE9",
    400: "#4C90E2",
    500: linkBlue,
    // Main color of this group
    600: "#195DAF",
    700: "#134683",
    800: "#0C2E58",
    900: "#06172C"
  },
  mint: {
    50: "#E2F5F0",
    100: "#D4F0E8",
    200: "#C5EBE0",
    300: "#A8E2D1",
    400: "#8BD8C1",
    500: mint,
    // Main color of this group
    600: "#63B9A0",
    700: "#4D907D",
    800: "#376759",
    900: "#213E35"
  },
  accent: {
    mint,
    seaBlue: "#72B0BD",
    lavender: "#D7A9E3",
    sunburstOrange: "#FF9800",
    lemonYellow: "#F9E27D",
    darkMint: "#008574",
    darkSeaBlue: "#005670",
    deepPurple: "#890C58",
    cherryPurple: "#CB333B",
    mustard: "#A38B00"
  }
};
const nationwideColorSystem = {
  // TODO: [FEP-530] - delete this
  brand: nationwideBaseColors.brandBlue,
  avatars: [{
    backgroundColor: nationwideBaseColors.accent.darkMint,
    color: nationwideBaseColors.neutral[0]
  }, {
    backgroundColor: nationwideBaseColors.accent.darkSeaBlue,
    color: nationwideBaseColors.neutral[0]
  }, {
    backgroundColor: nationwideBaseColors.accent.deepPurple,
    color: nationwideBaseColors.neutral[0]
  }, {
    backgroundColor: nationwideBaseColors.accent.cherryPurple,
    color: nationwideBaseColors.neutral[0]
  }, {
    backgroundColor: nationwideBaseColors.accent.mustard,
    color: nationwideBaseColors.neutral[0]
  }, {
    backgroundColor: nationwideBaseColors.accent.mint,
    color: nationwideBaseColors.neutral["900"]
  }, {
    backgroundColor: nationwideBaseColors.accent.seaBlue,
    color: nationwideBaseColors.neutral["900"]
  }, {
    backgroundColor: nationwideBaseColors.accent.lavender,
    color: nationwideBaseColors.neutral["900"]
  }, {
    backgroundColor: nationwideBaseColors.accent.sunburstOrange,
    color: nationwideBaseColors.neutral["900"]
  }, {
    backgroundColor: nationwideBaseColors.accent.lemonYellow,
    color: nationwideBaseColors.neutral["900"]
  }],
  text: {
    headline: nationwideBaseColors.brandBlue["500"],
    default: nationwideBaseColors.neutral["900"],
    subdued: nationwideBaseColors.neutral["800"],
    onColor: nationwideBaseColors.neutral["0"]
  },
  background: {
    default: nationwideBaseColors.neutral["0"],
    surface100: nationwideBaseColors.neutral["50"],
    surface200: nationwideBaseColors.neutral["200"],
    brand: nationwideBaseColors.brandBlue["500"],
    accentConsumer: nationwideBaseColors.brandBlue["500"],
    accentEnterprise: nationwideBaseColors.brandBlue["500"],
    informative: {
      default: nationwideBaseColors.brandBlue["500"],
      light: nationwideBaseColors.formBlue["100"]
    }
  },
  navigation: {
    backgroundAuto: nationwideBaseColors.neutral["0"],
    borderAuto: nationwideBaseColors.neutral["400"],
    textAuto: nationwideBaseColors.neutral["700"]
  },
  border: {
    default: nationwideBaseColors.neutral["400"],
    brand: nationwideBaseColors.brandBlue["500"],
    onColor: curriedTransparentize$1(0.8, "#FFFFFF"),
    // 20% opacity
    destructive: nationwideBaseColors.red["600"]
  },
  icon: {
    default: nationwideBaseColors.neutral["900"],
    subdued: nationwideBaseColors.neutral["700"],
    onColor: nationwideBaseColors.neutral["0"],
    brand: nationwideBaseColors.brandBlue["500"]
  },
  status: {
    success: {
      default: nationwideBaseColors.green["500"],
      light: nationwideBaseColors.green["150"],
      dark: nationwideBaseColors.green["700"]
    },
    critical: {
      default: nationwideBaseColors.red["500"],
      light: nationwideBaseColors.red["150"],
      dark: nationwideBaseColors.red["700"]
    },
    warning: {
      default: nationwideBaseColors.yellow["400"],
      light: nationwideBaseColors.yellow["150"],
      dark: nationwideBaseColors.yellow["700"]
    }
  },
  focus: nationwideBaseColors.formBlue["600"],
  buttons: {
    primary: {
      fill: {
        default: nationwideBaseColors.mint["500"],
        hover: nationwideBaseColors.mint["400"],
        pressed: nationwideBaseColors.mint["600"],
        disabled: nationwideBaseColors.neutral["300"]
      },
      text: {
        default: "#171717",
        disabled: nationwideBaseColors.neutral["500"]
      }
    },
    secondary: {
      fill: {
        default: "transparent",
        hover: nationwideBaseColors.neutral["300"],
        pressed: nationwideBaseColors.neutral["400"],
        disabled: "transparent"
      },
      text: {
        default: "#171717",
        disabled: "#d9d9d9"
      },
      border: {
        default: "#171717",
        hover: "#171717",
        disabled: nationwideBaseColors.neutral["500"]
      }
    },
    ghost: {
      focus: nationwideBaseColors.formBlue["600"],
      fill: {
        default: "transparent",
        hover: nationwideBaseColors.blue["50"],
        pressed: nationwideBaseColors.blue["100"],
        disabled: nationwideBaseColors.neutral["300"]
      },
      text: {
        default: nationwideBaseColors.neutral["800"],
        disabled: nationwideBaseColors.neutral["500"]
      }
    },
    destructive: {
      focus: nationwideBaseColors.red["600"],
      primary: {
        fill: {
          default: nationwideBaseColors.red["600"],
          hover: nationwideBaseColors.red["500"],
          pressed: nationwideBaseColors.red["800"],
          disabled: nationwideBaseColors.neutral["300"]
        },
        text: {
          default: nationwideBaseColors.neutral["0"],
          disabled: nationwideBaseColors.neutral["500"]
        }
      },
      secondary: {
        fill: {
          default: "transparent",
          hover: nationwideBaseColors.red["100"],
          pressed: nationwideBaseColors.red["400"]
        },
        text: {
          default: nationwideBaseColors.red["800"],
          disabled: nationwideBaseColors.neutral["500"]
        },
        border: {
          default: nationwideBaseColors.red["800"],
          disabled: nationwideBaseColors.neutral["500"]
        }
      },
      ghost: {
        focus: nationwideBaseColors.red["600"],
        fill: {
          default: "transparent",
          hover: nationwideBaseColors.red["100"],
          pressed: nationwideBaseColors.red["200"],
          disabled: nationwideBaseColors.neutral["300"]
        },
        text: {
          default: nationwideBaseColors.red["700"],
          disabled: nationwideBaseColors.neutral["500"]
        }
      }
    }
  },
  links: {
    disabled: "#bbb9b7",
    action: {
      default: nationwideBaseColors.linkBlue["500"],
      hover: nationwideBaseColors.linkBlue["400"],
      pressed: nationwideBaseColors.linkBlue["600"]
    },
    destructive: {
      default: nationwideBaseColors.red["800"],
      hover: nationwideBaseColors.red["600"],
      pressed: nationwideBaseColors.red["700"]
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: nationwideBaseColors.neutral["0"],
      hover: nationwideBaseColors.formBlue["300"],
      pressed: nationwideBaseColors.formBlue["600"],
      selected: nationwideBaseColors.formBlue["500"],
      selectedHover: nationwideBaseColors.formBlue["300"],
      activated: nationwideBaseColors.formBlue["400"],
      disabled: nationwideBaseColors.neutral["100"]
    },
    border: {
      default: nationwideBaseColors.neutral["400"],
      hover: nationwideBaseColors.formBlue["400"],
      pressed: nationwideBaseColors.formBlue["600"],
      selected: nationwideBaseColors.formBlue["500"]
    },
    text: {
      default: "#171717",
      selected: "#171717",
      disabled: curriedTransparentize$1(0.3, "#171717"),
      // 70% opacity of default text color
      hint: curriedTransparentize$1(0.65, "#171717")
      // 35% opacity of default text color
    }
  },
  iconInteraction: {
    disabled: nationwideBaseColors.neutral["500"],
    action: {
      default: nationwideBaseColors.linkBlue["500"],
      hover: nationwideBaseColors.linkBlue["400"],
      pressed: nationwideBaseColors.linkBlue["600"]
    },
    onColor: {
      default: "rgba(255, 255, 255)",
      hover: "#f3f3f3",
      pressed: "#d1d1d1"
    },
    destructive: {
      default: nationwideBaseColors.red["900"],
      hover: nationwideBaseColors.red["600"],
      pressed: nationwideBaseColors.red["700"]
    }
  },
  chart: {
    line: {
      L1: "#278904",
      L2: "#CC1AD4"
    },
    bar: {
      B1: "#4695D4",
      B2: "#38179E",
      B3: "#4695D4",
      B4: "#278904",
      B5: "#BA1C21"
    },
    area: {
      A1: "#38179E",
      A1Fill: "#5E65FB20"
    },
    pie: {
      P1: "#278904",
      P2: "#38179E",
      P3: "#4695D4"
    }
  }
};
const nationwideColors = extendsType()(merge({}, nationwideBaseColors, nationwideColorSystem));
const nationwideTypographyGroupsOverrides = extendsType()({
  headlineProps: {
    fontFamily: "Georgia",
    fontWeight: "700",
    color: brandBlue,
    lineHeight: "110%",
    fontSmoothing: "antialiased"
  },
  headerProps: {
    fontFamily: "Arial",
    fontWeight: "700",
    lineHeight: "120%",
    fontSmoothing: "antialiased"
  },
  bodyProps: {
    fontFamily: "Arial",
    fontWeight: "500",
    lineHeight: "140%",
    fontSmoothing: "antialiased"
  },
  labelProps: {
    fontFamily: "Arial",
    fontWeight: "300",
    textTransform: "uppercase",
    letterSpacing: "0.12em",
    fontSmoothing: "antialiased"
  },
  signatureProps: {
    fontFamily: "Caveat",
    fontSmoothing: "antialiased"
  },
  numericTextProps: {
    fontFamily: "Arial",
    fontSmoothing: "antialiased"
  },
  hyperlinkProps: {
    letterSpacing: "0%",
    fontWeight: "500",
    fontFamily: "Arial, sans-serif",
    fontSmoothing: "antialiased"
  },
  disclaimerProps: {
    letterSpacing: "0%",
    fontWeight: "400",
    fontFamily: "Arial, sans-serif",
    fontSmoothing: "antialiased"
  }
});
const NATIONWIDE_TOKENS = extendsType()({
  ...BASE_TOKENS,
  colors: nationwideColors,
  fonts: {
    ...BASE_FONTS,
    fontsToLoad: [FontLoaderFonts.Georgia, FontLoaderFonts.Arial, FontLoaderFonts.Caveat]
  }
});
const COLOR_TEXT_HEADLINE$5 = "#0047BB";
const COLOR_TEXT_DEFAULT$5 = "#282624";
const COLOR_TEXT_SUBDUED$5 = "#6E6B68";
const nationwideTypography = merge({}, buildTypographyVariants(nationwideTypographyGroupsOverrides)(NATIONWIDE_TOKENS), {
  headline: {
    fontFamily: "Georgia",
    fontWeight: "700",
    color: COLOR_TEXT_HEADLINE$5,
    letterSpacing: "-0.01em",
    lineHeight: "110%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: "Arial",
    fontWeight: "700",
    color: COLOR_TEXT_DEFAULT$5,
    lineHeight: "120%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: "Arial",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$5,
    colorSubdued: COLOR_TEXT_SUBDUED$5,
    lineHeight: "140%",
    uppercase: true,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: "Arial",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$5,
    colorSubdued: COLOR_TEXT_SUBDUED$5,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT$5,
    fontFamily: "Arial, sans-serif",
    fontWeight: "400",
    lineHeight: "150%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat, ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  }
});
const nationwideComponentStyles = {
  badges: {
    borderRadius: "4px",
    sizes: {
      compact: {
        borderRadius: "2px"
      }
    }
  },
  banners: {
    borderRadius: "4px"
  },
  card: {
    boxShadow: "none",
    borderRadius: "0px",
    actionFooterStyles: {
      color: linkBlue,
      fill: linkBlue,
      hoverStyle: {
        color: nationwideColors.linkBlue["600"],
        fill: nationwideColors.linkBlue["600"]
      },
      activeStyle: {
        color: nationwideColors.linkBlue["700"],
        fill: nationwideColors.linkBlue["700"]
      }
    }
  },
  spinners: {
    // Replacing the purple gradient with the static color
    spinnerColor: brandBlue
  },
  links: {
    variants: {
      auto: {
        color: nationwideColors.links.action.default,
        fill: nationwideColors.links.action.default,
        hoverStyle: {
          color: nationwideColors.links.action.hover
        },
        activeStyle: {
          color: nationwideColors.links.action.pressed
        }
      }
    }
  },
  highlightedCheckbox: {
    background: {
      default: "#DAEEF8",
      hover: formBlue,
      disabled: nationwideBaseColors.neutral["100"],
      invalid: nationwideBaseColors.red["50"]
    },
    background_image_color: {
      default: linkBlue,
      hover: brandBlue,
      disabled: nationwideBaseColors.neutral["400"],
      invalid: nationwideBaseColors.red["500"]
    },
    outline: {
      focus: nationwideColors.focus
    },
    textColor: {
      disabled: nationwideBaseColors.neutral["600"]
    }
  },
  inputs: {
    // TODO: This can be removed if Rotunda spacing is normalized.
    // It's a result of BESTOW_INPUTS's marginTop normalizing Rotunda's spacing
    marginTop: "14px",
    marginBottom: "14px",
    // More targeted selecting of the bottom padding for SelectInput components, if this isn't set, marginBottom will be used
    selectPaddingBottom: "4px",
    bullets: {
      variants: {
        checked: {
          background: formBlue,
          borderColor: formBlue,
          hoverStyle: {
            background: formBlue
          }
        }
      }
    },
    allCaps: false
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/nationwide-onLight.svg", "Nationwide"),
        logoMark: getStaticAssetUrl("/Logos/nationwide-logomark-onLight.svg", "Nationwide")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/nationwide-onDark.svg", "Nationwide"),
        logoMark: getStaticAssetUrl("/Logos/nationwide-logomark-onDark.svg", "Nationwide")
      },
      auto: "onLight"
    }
  },
  sliderInput: {
    thumbStyle: {
      color: nationwideColors.neutral["900"]
    }
  },
  divider: {
    variants: {
      accent: {
        background: nationwideColors.border.default
      }
    }
  },
  percentageBar: {
    activeBg: formBlue
  },
  popovers: {
    variants: {
      card: {
        borderRadius: "4px"
      },
      tooltip: {
        background: nationwideColors.neutral["900"],
        color: nationwideColors.text.onColor
      }
    }
  },
  signature: {
    background: {
      default: "#DAEEF8",
      hover: formBlue,
      disabled: nationwideBaseColors.neutral["100"]
    },
    borderColor: {
      default: linkBlue,
      hover: brandBlue,
      disabled: nationwideBaseColors.neutral["500"]
    },
    textColor: {
      disabled: "#6e6b68"
    }
  }
};
const NATIONWIDE_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(NATIONWIDE_TOKENS, nationwideTypography),
  name: "Nationwide Theme",
  key: "NATIONWIDE_THEME"
}, nationwideComponentStyles));
const BASE_COLOR_SCALES$3 = {
  neutral: {
    0: "#FFFFFF",
    50: "#FAFAFA",
    100: "#F8F8F8",
    200: "#F3F3F3",
    300: "#E8E8E8",
    400: "#D1D1D1",
    500: "#BBBBBB",
    600: "#9B9B9B",
    700: "#6E6E6E",
    800: "#464646",
    900: "#282624"
  },
  red: {
    50: "#FEF6F6",
    100: "#FCE4E3",
    150: "#EE0000",
    200: "#F6BCB6",
    300: "#F09D94",
    400: "#E87F73",
    500: "#CB1D15",
    600: "#B71A13",
    700: "#A21711",
    800: "#8D140E",
    900: "#78110C"
  },
  green: {
    50: "#EDF8F4",
    100: "#D1E8DF",
    200: "#ADCFC2",
    300: "#5FAE91",
    400: "#169269",
    500: "#13805C",
    600: "#106A4C",
    700: "#0C543C",
    800: "#093D2C",
    900: "#06271C"
  },
  yellow: {
    50: "#FDF9F6",
    100: "#FFF9EE",
    150: "#FFF5E5",
    200: "#FFECC7",
    300: "#FFDEA0",
    400: "#FFC453",
    500: "#DDA63E",
    600: "#BB8A2C",
    700: "#996E1D",
    800: "#775411",
    900: "#553B09"
  },
  blue: {
    50: "#F5F7F7",
    100: "#E9F0F1",
    200: "#D5EBEF",
    300: "#B2E3EC",
    400: "#7DD9E8",
    500: "#39B2C6",
    600: "#238C9D",
    700: "#177482",
    800: "#0C5561",
    900: "#0B3541"
  }
};
const usaaBaseColors = {
  ...BASE_COLOR_SCALES$3,
  // TODO: [FEP-530] - delete this
  brand: {}
};
const usaaColorSystem = {
  // TODO: [FEP-530] - delete this
  brand: usaaBaseColors.brand,
  avatars: [{
    backgroundColor: usaaBaseColors.blue[900],
    color: usaaBaseColors.neutral["0"]
  }, {
    backgroundColor: usaaBaseColors.blue[700],
    color: usaaBaseColors.neutral["0"]
  }, {
    backgroundColor: usaaBaseColors.blue[500],
    color: usaaBaseColors.neutral["0"]
  }, {
    backgroundColor: usaaBaseColors.red[400],
    color: "#0B2237"
  }, {
    backgroundColor: usaaBaseColors.yellow[400],
    color: "#0B2237"
  }],
  text: {
    headline: "#0B2237",
    default: "#0B2237",
    subdued: "#4E4E4F",
    onColor: usaaBaseColors.neutral["0"]
  },
  background: {
    default: usaaBaseColors.neutral["0"],
    surface100: usaaBaseColors.neutral["50"],
    surface200: usaaBaseColors.neutral["200"],
    brand: "#12395B",
    accentConsumer: "#12395B",
    accentEnterprise: "#12395B",
    informative: {
      default: "#0058A0",
      light: "#E6F1FA"
    }
  },
  navigation: {
    backgroundAuto: "#12395B",
    borderAuto: "#12395B",
    textAuto: usaaBaseColors.neutral["0"]
  },
  border: {
    default: "#DADBDC",
    brand: "#12395B",
    onColor: curriedTransparentize$1(0.8, "#FFFFFF"),
    // 20% opacity
    destructive: "#b40000"
  },
  icon: {
    default: "#0B2237",
    subdued: usaaBaseColors.neutral["700"],
    onColor: usaaBaseColors.neutral["0"],
    brand: "#12395B"
  },
  status: {
    success: {
      default: "#0A7800",
      light: "#E8F3E8",
      dark: "#075400"
    },
    warning: {
      default: "#FAC705",
      light: "#FEF4CD",
      dark: "#CFA400"
    },
    critical: {
      default: "#B40000",
      light: "#FFECED",
      dark: "#FFECED"
    }
  },
  focus: "#006EC8",
  buttons: {
    primary: {
      fill: {
        default: "#006EC8",
        hover: "#0058A0",
        pressed: "#0058A0",
        disabled: "#8B8D8F"
      },
      text: {
        default: usaaBaseColors.neutral["0"],
        disabled: usaaBaseColors.neutral["0"]
      }
    },
    secondary: {
      fill: {
        default: "transparent",
        hover: "#E9F1FA",
        pressed: "#D3E4F5",
        disabled: "transparent"
      },
      text: {
        default: "#006EC8",
        disabled: "#8B8D8F"
      },
      border: {
        default: "#006EC8",
        hover: "#006EC8",
        disabled: "#8B8D8F"
      }
    },
    ghost: {
      focus: "#006EC8",
      fill: {
        default: "transparent",
        hover: "#E9F1FA",
        pressed: "#D3E4F5",
        disabled: "#E8E8E8"
      },
      text: {
        default: "#006EC8",
        disabled: "#8B8D8F"
      }
    },
    destructive: {
      focus: "#B40000",
      primary: {
        fill: {
          default: "#B40000",
          hover: "#900000",
          pressed: "#900000",
          disabled: "#8B8D8F"
        },
        text: {
          default: "#FFFFFF",
          disabled: usaaBaseColors.neutral["0"]
        }
      },
      secondary: {
        fill: {
          default: "transparent",
          hover: "#FCE4E3",
          pressed: "#E87F73"
        },
        text: {
          default: "#B40000",
          disabled: "#8B8D8F"
        },
        border: {
          default: "#B40000",
          disabled: "#8B8D8F"
        }
      },
      ghost: {
        focus: "#B71A13",
        fill: {
          default: "transparent",
          hover: "#FCE4E3",
          pressed: "#F6BCB6",
          disabled: "#DADBDC"
        },
        text: {
          default: "#A21711",
          disabled: "#8B8D8F"
        }
      }
    }
  },
  links: {
    disabled: "#8B8D8F",
    action: {
      default: "#006EC8",
      hover: "#0058A0",
      pressed: "#0058A0"
    },
    destructive: {
      default: "#B40000",
      hover: "#900000",
      pressed: "#900000"
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: usaaBaseColors.neutral["0"],
      hover: "#F8F8F8",
      pressed: "#E8E8E8",
      selected: "#006EC8",
      selectedHover: "#0058A0",
      disabled: usaaBaseColors.neutral["200"],
      activated: "#006EC8"
    },
    border: {
      default: "#8B8D8F",
      hover: "#8B8D8F",
      pressed: "#6C6E70",
      selected: "#006EC8"
    },
    text: {
      default: "#0B2237",
      selected: "#FFFFFF",
      disabled: curriedTransparentize$1(0.3, "#0B2237"),
      // 70% opacity of default text color
      hint: curriedTransparentize$1(0.65, "#0B2237")
      // 35% opacity of default text color
    }
  },
  iconInteraction: {
    disabled: "#BBBBBB",
    action: {
      default: "#006EC8",
      hover: "#0058A0",
      pressed: "#0058A0"
    },
    onColor: {
      default: "rgba(255, 255, 255, 1)",
      hover: "rgba(255, 255, 255, 0.8)",
      pressed: "rgba(255, 255, 255, 0.9)"
    },
    destructive: {
      default: "#B40000",
      hover: "#900000",
      pressed: "#900000"
    }
  },
  chart: {
    line: {
      L1: "#278904",
      L2: "#CC1AD4"
    },
    bar: {
      B1: "#4695D4",
      B2: "#38179E",
      B3: "#4695D4",
      B4: "#278904",
      B5: "#BA1C21"
    },
    area: {
      A1: "#38179E",
      A1Fill: "#5E65FB20"
    },
    pie: {
      P1: "#278904",
      P2: "#38179E",
      P3: "#4695D4"
    }
  }
};
const usaaColors = extendsType()(merge({}, usaaBaseColors, usaaColorSystem));
const usaaTypographyGroupsOverrides = extendsType()({
  headlineProps: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "700",
    color: usaaColorSystem.text.headline,
    lineHeight: "110%"
  },
  headerProps: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "700",
    lineHeight: "120%"
  },
  bodyProps: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "400",
    lineHeight: "140%"
  },
  labelProps: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "500",
    letterSpacing: "0.0175rem"
  },
  signatureProps: {
    fontFamily: "Caveat, ui-sans-serif"
  },
  numericTextProps: {
    fontFamily: "Gotham Narrow, sans-serif"
  },
  hyperlinkProps: {
    letterSpacing: "0%",
    fontWeight: "500",
    fontFamily: "Gotham Narrow, sans-serif"
  },
  disclaimerProps: {
    letterSpacing: "0%",
    fontWeight: "400",
    fontFamily: "Gotham Narrow, sans-serif"
  }
});
const usaaTokens = extendsType()({
  ...BASE_TOKENS,
  colors: usaaColors,
  fonts: {
    ...BASE_FONTS,
    fontsToLoad: [FontLoaderFonts.Caveat, FontLoaderFonts["Gotham Narrow"]]
  }
});
const COLOR_TEXT_HEADLINE$4 = "#0B2237";
const COLOR_TEXT_DEFAULT$4 = "#0B2237";
const COLOR_TEXT_SUBDUED$4 = "#4E4E4F";
const usaaTypography = merge({}, buildTypographyVariants(usaaTypographyGroupsOverrides)(usaaTokens), {
  headline: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "700",
    color: COLOR_TEXT_HEADLINE$4,
    letterSpacing: "-0.01em",
    lineHeight: "110%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "700",
    color: COLOR_TEXT_DEFAULT$4,
    lineHeight: "120%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "500",
    color: COLOR_TEXT_DEFAULT$4,
    colorSubdued: COLOR_TEXT_SUBDUED$4,
    lineHeight: "140%",
    uppercase: false,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$4,
    colorSubdued: COLOR_TEXT_SUBDUED$4,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT$4,
    fontFamily: "Gotham Narrow, sans-serif",
    fontWeight: "400",
    lineHeight: "160%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat, ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  }
});
const usaaComponentStyles = {
  sliderInput: {
    hideFeet: false
  },
  toasts: {
    variants: {
      info: {
        backgroundColor: usaaColors.background.brand,
        color: usaaColors.text.onColor,
        fill: usaaColors.text.onColor
      }
    }
  },
  accordionItem: {
    background: usaaColors.neutral[200]
  },
  popovers: {
    variants: {
      card: {
        borderRadius: "4px"
      },
      tooltip: {
        background: usaaColors.background.brand,
        backgroundColor: usaaColors.background.brand
      }
    }
  },
  inputs: {
    fontWeight: "400",
    labelStyles: {
      fontWeight: "400"
    },
    allCaps: true
  },
  links: {
    variants: {
      auto: {
        color: usaaColors.links.onColor.default,
        fill: usaaColors.links.onColor.default,
        hoverStyle: {
          color: usaaColors.links.onColor.hover
        },
        activeStyle: {
          color: usaaColors.links.onColor.pressed
        }
      }
    }
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/usaa-onLight.svg", "USAA"),
        logoMark: getStaticAssetUrl("/Logos/usaa-logomark-onLight.svg", "USAA")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/usaa-onDark.svg", "USAA"),
        logoMark: getStaticAssetUrl("/Logos/usaa-logomark-onDark.svg", "USAA")
      },
      auto: "onDark"
    }
  },
  highlightedCheckbox: {
    background: {
      default: usaaColors.buttons.secondary.fill.hover,
      hover: usaaColors.buttons.secondary.fill.pressed,
      disabled: usaaBaseColors.neutral["300"],
      invalid: usaaColors.status.critical.light
    },
    background_image_color: {
      default: usaaColors.focus,
      hover: "#0C416E",
      disabled: usaaColors.buttons.primary.fill.disabled,
      invalid: usaaColors.status.critical.default
    },
    outline: {
      focus: usaaColors.focus
    },
    textColor: {
      disabled: usaaColors.text.subdued
    }
  },
  percentageBar: {
    activeBg: usaaColors.forms.fill.activated
  },
  badges: {
    borderRadius: "4px",
    sizes: {
      compact: {
        borderRadius: "2px"
      }
    }
  },
  banners: {
    borderRadius: "4px"
  },
  signature: {
    background: {
      default: "#E9F1FA",
      hover: "#D3E4F5",
      disabled: usaaBaseColors.neutral["200"]
    },
    borderColor: {
      default: "#006EC8",
      hover: "#0C416E",
      disabled: "#BBBBBB"
    },
    textColor: {
      disabled: "#4E4E4F"
    }
  },
  card: {
    borderRadius: "4px"
  }
};
const USAA_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(usaaTokens, usaaTypography),
  name: "USAA Theme",
  key: "USAA_THEME"
}, usaaComponentStyles));
const BASE_COLOR_SCALES$2 = {
  neutral: {
    0: "#FFFFFF",
    50: "#FAFAFA",
    100: "#F8F8F8",
    200: "#F3F3F3",
    300: "#E8E8E8",
    400: "#D1D1D1",
    500: "#BBBBBB",
    600: "#9B9B9B",
    700: "#6E6E6E",
    800: "#464646",
    900: "#282624"
  },
  red: {
    50: "#FEF6F6",
    100: "#FCE4E3",
    150: "#EE0000",
    200: "#F6BCB6",
    300: "#F09D94",
    400: "#E87F73",
    500: "#CB1D15",
    600: "#B71A13",
    700: "#A21711",
    800: "#8D140E",
    900: "#78110C"
  },
  green: {
    50: "#EDF8F4",
    100: "#D1E8DF",
    200: "#ADCFC2",
    300: "#5FAE91",
    400: "#169269",
    500: "#13805C",
    600: "#106A4C",
    700: "#0C543C",
    800: "#093D2C",
    900: "#06271C"
  },
  yellow: {
    50: "#FDF9F6",
    100: "#FFF9EE",
    150: "#FFF5E5",
    200: "#FFECC7",
    300: "#FFDEA0",
    400: "#FFC453",
    500: "#DDA63E",
    600: "#BB8A2C",
    700: "#996E1D",
    800: "#775411",
    900: "#553B09"
  },
  blue: {
    50: "#F5F7F7",
    100: "#E9F0F1",
    200: "#D5EBEF",
    300: "#B2E3EC",
    400: "#7DD9E8",
    500: "#39B2C6",
    600: "#238C9D",
    700: "#177482",
    800: "#0C5561",
    900: "#0B3541"
  }
};
const transamericaBaseColors = {
  ...BASE_COLOR_SCALES$2,
  someBrandedColors: {}
};
const transamericaColorSystem = {
  brand: {},
  avatars: [{
    backgroundColor: "#1F355E",
    color: "#FFFFFF"
  }, {
    backgroundColor: "#C7E6FD",
    color: "#222222"
  }, {
    backgroundColor: "#0069B4",
    color: "#FFFFFF"
  }, {
    backgroundColor: "#474B4E",
    color: "#FFFFFF"
  }, {
    backgroundColor: "#E0F6F6",
    color: "#222222"
  }, {
    backgroundColor: "#2FADAE",
    color: "#FFFFFF"
  }, {
    backgroundColor: "#007C86",
    color: "#FFFFFF"
  }, {
    backgroundColor: "#ACACAC",
    color: "#222222"
  }, {
    backgroundColor: "#666666",
    color: "#FFFFFF"
  }],
  text: {
    headline: "#222222",
    default: "#222222",
    subdued: "#474B4E",
    onColor: "#FFFFFF"
  },
  background: {
    default: "#FFFFFF",
    surface100: "#FAFAFA",
    surface200: "#F3F3F3",
    brand: transamericaBaseColors.blue["900"],
    accentConsumer: "#1F355E",
    accentEnterprise: "#1F355E",
    informative: {
      default: "#0069B4",
      light: "#E6F0F8"
    }
  },
  navigation: {
    backgroundAuto: transamericaBaseColors.neutral["0"],
    borderAuto: transamericaBaseColors.neutral["400"],
    textAuto: transamericaBaseColors.neutral["700"]
  },
  border: {
    default: "#D1D1D1",
    brand: "#BE0000",
    onColor: "#FFFFFF",
    destructive: "#B71A13"
  },
  icon: {
    default: "#282624",
    subdued: "#757575",
    onColor: "#FFFFFF",
    brand: "#EE0000"
  },
  status: {
    success: {
      default: "#007C86",
      light: "#E0F6F6",
      dark: "#005056"
    },
    warning: {
      default: "#FFAD00",
      light: "#FEF3D4",
      dark: "#B67E06"
    },
    critical: {
      default: "#D61E58",
      light: "#F7DCE4",
      dark: "#96123C"
    }
  },
  focus: "#0069B4",
  buttons: {
    primary: {
      fill: {
        default: "#0069B4",
        hover: "#0361A4",
        pressed: "#365A84",
        disabled: "#666666"
      },
      text: {
        default: "#FFFFFF",
        disabled: "#FFFFFF"
      }
    },
    secondary: {
      fill: {
        default: "transparent",
        hover: curriedTransparentize$1(0.7, "#CEE6F8"),
        // 30% opacity of default text color
        pressed: curriedTransparentize$1(0.4, "#CEE6F8"),
        // 60% opacity of default text color
        disabled: "transparent"
      },
      text: {
        default: "#0069B4",
        disabled: "#757575"
      },
      border: {
        default: "#0069B4",
        hover: "#3387C3",
        disabled: "#DDDDDD"
      }
    },
    ghost: {
      focus: "#0069B4",
      fill: {
        default: "transparent",
        hover: curriedTransparentize$1(0.7, "#CEE6F8"),
        // 30% opacity of default text color
        pressed: curriedTransparentize$1(0.4, "#CEE6F8"),
        // 60% opacity of default text color
        disabled: transamericaBaseColors.neutral["300"]
      },
      text: {
        default: "#0069B4",
        disabled: transamericaBaseColors.neutral["600"]
      }
    },
    destructive: {
      focus: "#B71A13",
      primary: {
        fill: {
          default: "#B71A13",
          hover: "#CB1D15",
          pressed: "#8D140E",
          disabled: transamericaBaseColors.neutral["300"]
        },
        text: {
          default: "#FFFFFF",
          disabled: transamericaBaseColors.neutral["500"]
        }
      },
      secondary: {
        fill: {
          default: "transparent",
          hover: "#FCE4E3",
          pressed: "#E87F73"
        },
        text: {
          default: "#8D140E",
          disabled: transamericaBaseColors.neutral["500"]
        },
        border: {
          default: "#8D140E",
          disabled: transamericaBaseColors.neutral["500"]
        }
      },
      ghost: {
        focus: transamericaBaseColors.red["600"],
        fill: {
          default: "transparent",
          hover: transamericaBaseColors.red["100"],
          pressed: transamericaBaseColors.red["200"],
          disabled: transamericaBaseColors.neutral["400"]
        },
        text: {
          default: transamericaBaseColors.red["700"],
          disabled: transamericaBaseColors.neutral["600"]
        }
      }
    }
  },
  links: {
    disabled: "#757575",
    action: {
      default: "#0069B4",
      hover: "#2E84C2",
      pressed: "#1F355E"
    },
    destructive: {
      default: "#8D140E",
      hover: "#B71A13",
      pressed: "#A21711"
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: "#FFFFFF",
      hover: "#F3F3F3",
      pressed: "#D1D1D1",
      selected: "#0069B4",
      selectedHover: "#3387C3",
      disabled: "#E8E8E8",
      activated: "#3387C3"
    },
    border: {
      default: "#666666",
      hover: "#6E6E6E",
      pressed: "#D1D1D1",
      selected: "#0069B4"
    },
    text: {
      default: "#222222",
      selected: "#FFFFFF",
      disabled: curriedTransparentize$1(0.3, "#222222"),
      // 70% opacity of default text color
      hint: curriedTransparentize$1(0.65, "#222222")
      // 35% opacity of default text color
    }
  },
  iconInteraction: {
    disabled: "#757575",
    action: {
      default: "#0069B4",
      hover: "#2E84C2",
      pressed: "#1F355E"
    },
    onColor: {
      default: "#FFFFFF",
      hover: "rgba(217, 217, 217, 0.8)",
      pressed: "rgba(255, 255, 255, 0.9)"
    },
    destructive: {
      default: "#78110C",
      hover: "#B71A13",
      pressed: "#A21711"
    }
  },
  chart: {
    line: {
      L1: "#278904",
      L2: "#CC1AD4"
    },
    bar: {
      B1: "#4695D4",
      B2: "#38179E",
      B3: "#4695D4",
      B4: "#278904",
      B5: "#BA1C21"
    },
    area: {
      A1: "#38179E",
      A1Fill: "#6F6B664D"
    },
    pie: {
      P1: "#278904",
      P2: "#38179E",
      P3: "#4695D4"
    }
  }
};
const transamericaColors = extendsType()(merge({}, transamericaBaseColors, transamericaColorSystem));
const transamericaTypographyGroupsOverrides = extendsType()({
  headlineProps: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "600",
    color: transamericaColors.text.headline,
    lineHeight: "110%",
    fontSmoothing: "antialiased"
  },
  headerProps: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "600",
    lineHeight: "140%",
    fontSmoothing: "antialiased"
  },
  bodyProps: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "400",
    lineHeight: "160%",
    fontSmoothing: "antialiased"
  },
  labelProps: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "1.68px",
    fontSmoothing: "antialiased"
  },
  signatureProps: {
    fontFamily: "Caveat, ui-sans-serif",
    variants: {
      desktop: {
        fontSize: BASE_FONTS.sizes[32]
      }
    },
    fontSmoothing: "antialiased"
  },
  numericTextProps: {
    fontFamily: "Whitney, sans-serif",
    fontSmoothing: "antialiased"
  },
  hyperlinkProps: {
    fontFamily: `Whitney, sans-serif`,
    fontWeight: "600",
    fontSmoothing: "antialiased"
  },
  disclaimerProps: {
    fontFamily: `Whitney, , sans-serif`,
    fontWeight: "400",
    letterSpacing: "0rem",
    fontSmoothing: "antialiased"
  }
});
const transamericaTokens = extendsType()({
  ...BASE_TOKENS,
  colors: transamericaColors,
  fonts: {
    ...BASE_FONTS,
    fontsToLoad: [FontLoaderFonts.Whitney, FontLoaderFonts.Caveat]
  }
});
const COLOR_TEXT_HEADLINE$3 = "#282624";
const COLOR_TEXT_DEFAULT$3 = "#282624";
const COLOR_TEXT_SUBDUED$3 = "#474B4E";
const transamericaTypography = merge({}, buildTypographyVariants(transamericaTypographyGroupsOverrides)(transamericaTokens), {
  headline: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "600",
    color: COLOR_TEXT_HEADLINE$3,
    letterSpacing: "normal",
    lineHeight: "110%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "600",
    color: COLOR_TEXT_DEFAULT$3,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "600",
    color: COLOR_TEXT_DEFAULT$3,
    colorSubdued: COLOR_TEXT_SUBDUED$3,
    lineHeight: "160%",
    uppercase: true,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: "Whitney, sans-serif",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$3,
    colorSubdued: COLOR_TEXT_SUBDUED$3,
    lineHeight: "160%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT$3,
    fontFamily: "Whitney, sans-serif",
    fontWeight: "400",
    lineHeight: "160%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat, ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  }
});
const transamericaComponentStyles = {
  card: {
    borderRadius: "3px"
  },
  inputs: {
    borderRadius: "6px",
    fontWeight: "400",
    labelStyles: {
      fontWeight: "400"
    },
    allCaps: true
  },
  links: {
    variants: {
      auto: {
        color: transamericaColors.links.action.default,
        fill: transamericaColors.links.action.default,
        hoverStyle: {
          color: transamericaColors.links.action.hover
        },
        activeStyle: {
          color: transamericaColors.links.action.pressed
        }
      }
    }
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/transamerica-onLight.svg", "Transamerica"),
        logoMark: getStaticAssetUrl("/Logos/transamerica-logomark-onLight.svg", "Transamerica")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/transamerica-onDark.svg", "Transamerica"),
        logoMark: getStaticAssetUrl("/Logos/transamerica-logomark-onDark.svg", "Transamerica")
      },
      auto: "onLight"
    }
  },
  highlightedCheckbox: {
    background: {
      default: "rgba(206, 230, 248, 0.1)",
      hover: "#CEE6F8",
      disabled: transamericaBaseColors.neutral["300"],
      invalid: transamericaColors.status.critical.light
    },
    background_image_color: {
      default: transamericaColors.focus,
      hover: transamericaColors.background.accentEnterprise,
      disabled: transamericaBaseColors.neutral["500"],
      invalid: transamericaColors.status.critical.default
    },
    outline: {
      focus: transamericaColors.focus
    },
    textColor: {
      disabled: transamericaColors.text.subdued
    }
  },
  percentageBar: {
    border: "none"
  },
  divider: {
    variants: {
      default: {
        bg: "#ededed"
      }
    }
  },
  badges: {
    borderRadius: "3px",
    sizes: {
      compact: {
        borderRadius: "1.5px"
      }
    }
  },
  banners: {
    borderRadius: "2px",
    variants: {
      informational: {
        bg: "#0069b4",
        color: "#ffffff"
      },
      informationalWeak: {
        bg: "#e6f0f8"
      },
      warning: {
        bg: "#ffad00"
      },
      warningWeak: {
        bg: "#fef3d4"
      },
      error: {
        bg: "#d61e58",
        color: "#ffffff"
      },
      errorWeak: {
        bg: "#f7dce4"
      },
      success: {
        bg: "#007c86",
        color: "#ffffff"
      },
      successWeak: {
        bg: "#edf8f4"
      }
    }
  },
  signature: {
    background: {
      default: "rgba(206, 230, 248, 0.1)",
      hover: "#CEE6F8",
      disabled: "#E8E8E8"
    },
    borderColor: {
      default: "#0069B4",
      hover: "#1F355E",
      disabled: "#BBBBBB"
    },
    textColor: {
      disabled: "#474B4E"
    }
  }
};
const TRANSAMERICA_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(transamericaTokens, transamericaTypography),
  name: "Transamerica Theme",
  key: "TRANSAMERICA_THEME"
}, transamericaComponentStyles));
const BASE_COLOR_SCALES$1 = {
  neutral: {
    0: "#FFFFFF",
    50: "#F9F9F9",
    100: "#F4F4F4",
    200: "#EEEEEE",
    300: "#E9E9E9",
    400: "#CCCCCD",
    500: "#AFB0B2",
    600: "#929496",
    700: "#6F7276",
    800: "#333333",
    900: "#000000"
  },
  red: {
    50: "#FFEDED",
    100: "#FFE2E1",
    150: "#EE0000",
    200: "#FFCFCD",
    300: "#FFA7A3",
    400: "#FF7F79",
    500: "#FF5750",
    600: "#DD4343",
    700: "#BB3036",
    800: "#991D2A",
    900: "#7D0B1B"
  },
  green: {
    50: "#D4F7EE",
    100: "#AAF0DE",
    200: "#7FE9CE",
    300: "#55E2BE",
    400: "#2ADBAE",
    500: "#00D49E",
    600: "#00B48F",
    700: "#007E71",
    800: "#00545B",
    900: "#004449"
  },
  yellow: {
    50: "#FDF9F6",
    100: "#FFF9EE",
    150: "#FFF5E5",
    200: "#FFECC7",
    300: "#FFDEA0",
    400: "#FFC453",
    500: "#DDA63E",
    600: "#BB8A2C",
    700: "#996E1D",
    800: "#775411",
    900: "#553B09"
  },
  purple: {
    50: "#E6E5FE",
    100: "#D1CBFD",
    200: "#BCB2FC",
    300: "#A899FB",
    400: "#937FFA",
    500: "#7E66F9",
    600: "#6A4DF8",
    700: "#4D32D1",
    800: "#3B25A8",
    900: "#2A168C"
  },
  blue: {
    50: "#F0F6FC",
    100: "#DAEEFF",
    200: "#B9DEFF",
    300: "#9FD3FF",
    400: "#73BFFF",
    500: "#5394FF",
    600: "#3369FF",
    700: "#2252D1",
    800: "#113CA4",
    900: "#002677"
  }
};
const equitableBaseColors = {
  ...BASE_COLOR_SCALES$1,
  someBrandedColors: {}
};
const equitableEnterpriseColors = {
  // TODO: [FEP-530] - delete this
  brand: {},
  text: {
    default: equitableBaseColors.neutral["800"],
    headline: equitableBaseColors.blue["900"],
    subdued: equitableBaseColors.neutral["700"],
    onColor: equitableBaseColors.neutral["0"]
  },
  avatars: [{
    backgroundColor: equitableBaseColors.blue[900],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.blue[700],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.blue[500],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.blue[300],
    color: equitableBaseColors.neutral[800]
  }, {
    backgroundColor: equitableBaseColors.blue[100],
    color: equitableBaseColors.neutral[800]
  }, {
    backgroundColor: equitableBaseColors.green[700],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.green[500],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.green[200],
    color: equitableBaseColors.neutral[800]
  }, {
    backgroundColor: equitableBaseColors.purple[600],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.purple[300],
    color: equitableBaseColors.neutral[800]
  }, {
    backgroundColor: equitableBaseColors.purple[50],
    color: equitableBaseColors.neutral[800]
  }, {
    backgroundColor: equitableBaseColors.red[800],
    color: equitableBaseColors.neutral[0]
  }, {
    backgroundColor: equitableBaseColors.red[500],
    color: equitableBaseColors.neutral[800]
  }, {
    backgroundColor: equitableBaseColors.red[200],
    color: equitableBaseColors.neutral[800]
  }],
  background: {
    default: equitableBaseColors.neutral["0"],
    surface100: equitableBaseColors.neutral["50"],
    surface200: equitableBaseColors.neutral["200"],
    brand: equitableBaseColors.blue["900"],
    accentConsumer: equitableBaseColors.blue["900"],
    accentEnterprise: equitableBaseColors.blue["900"],
    informative: {
      default: equitableBaseColors.blue["900"],
      light: equitableBaseColors.blue["50"]
    }
  },
  navigation: {
    backgroundAuto: equitableBaseColors.blue["900"],
    borderAuto: equitableBaseColors.blue["900"],
    textAuto: equitableBaseColors.neutral["0"]
  },
  border: {
    default: equitableBaseColors.neutral["400"],
    brand: equitableBaseColors.blue["600"],
    onColor: curriedTransparentize$1(0.8, "#FFFFFF"),
    // 20% opacity
    destructive: "#B71A13"
  },
  icon: {
    default: equitableBaseColors.neutral["800"],
    subdued: equitableBaseColors.neutral["700"],
    onColor: equitableBaseColors.neutral["0"],
    brand: equitableBaseColors.blue["900"]
  },
  buttons: {
    primary: {
      fill: {
        default: equitableBaseColors.blue["600"],
        hover: equitableBaseColors.blue["800"],
        pressed: equitableBaseColors.blue["900"],
        disabled: equitableBaseColors.neutral["300"]
      },
      text: {
        default: equitableBaseColors.neutral["0"],
        disabled: equitableBaseColors.neutral["600"]
      }
    },
    secondary: {
      fill: {
        default: "transparent",
        hover: "transparent",
        pressed: "transparent",
        disabled: "transparent"
      },
      text: {
        default: equitableBaseColors.blue["600"],
        disabled: equitableBaseColors.neutral["600"]
      },
      border: {
        default: equitableBaseColors.blue["600"],
        hover: equitableBaseColors.blue["600"],
        disabled: equitableBaseColors.neutral["500"]
      }
    },
    ghost: {
      focus: equitableBaseColors.blue["600"],
      fill: {
        default: "transparent",
        hover: equitableBaseColors.blue["50"],
        pressed: equitableBaseColors.blue["100"],
        disabled: equitableBaseColors.neutral["300"]
      },
      text: {
        default: equitableBaseColors.neutral["800"],
        disabled: equitableBaseColors.neutral["500"]
      }
    },
    destructive: {
      focus: "#B71A13",
      primary: {
        fill: {
          default: "#B71A13",
          hover: "#CB1D15",
          pressed: "#A21711",
          disabled: "#E9E9E9"
        },
        text: {
          default: equitableBaseColors.neutral["0"],
          disabled: equitableBaseColors.neutral["500"]
        }
      },
      secondary: {
        fill: {
          default: "transparent",
          hover: "#FCE4E3",
          pressed: "#F6BCB6"
        },
        text: {
          default: "#A21711",
          disabled: equitableBaseColors.neutral["500"]
        },
        border: {
          default: "#A21711",
          disabled: equitableBaseColors.neutral["500"]
        }
      },
      ghost: {
        focus: equitableBaseColors.red["600"],
        fill: {
          default: "transparent",
          hover: equitableBaseColors.red["100"],
          pressed: equitableBaseColors.red["200"],
          disabled: equitableBaseColors.neutral["300"]
        },
        text: {
          default: equitableBaseColors.neutral["700"],
          disabled: equitableBaseColors.neutral["500"]
        }
      }
    }
  },
  status: {
    success: {
      default: "#13805C",
      light: "#EDF8F4",
      dark: "#0C543C"
    },
    critical: {
      default: "#CB1D15",
      light: "#FEF6F6",
      dark: "#A21711"
    },
    warning: {
      default: "#FFC453",
      light: "#FFF5E5",
      dark: "#996E1D"
    }
  },
  focus: equitableBaseColors.blue["600"],
  links: {
    disabled: equitableBaseColors.neutral["600"],
    action: {
      default: equitableBaseColors.blue["600"],
      hover: equitableBaseColors.blue["800"],
      pressed: equitableBaseColors.blue["900"]
    },
    destructive: {
      default: "#8D140E",
      hover: "#CB1D15",
      pressed: "#A21711"
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: equitableBaseColors.neutral["0"],
      hover: equitableBaseColors.neutral["200"],
      pressed: equitableBaseColors.neutral["0"],
      selected: equitableBaseColors.blue["100"],
      selectedHover: equitableBaseColors.blue["100"],
      activated: equitableBaseColors.blue["600"],
      disabled: equitableBaseColors.neutral["100"]
    },
    border: {
      default: equitableBaseColors.neutral["400"],
      hover: equitableBaseColors.blue["600"],
      pressed: equitableBaseColors.blue["600"],
      selected: equitableBaseColors.neutral["400"]
    },
    text: {
      default: equitableBaseColors.neutral["800"],
      selected: equitableBaseColors.neutral["800"],
      disabled: curriedTransparentize$1(0.3, equitableBaseColors.neutral["600"]),
      // 70% opacity of default text color
      hint: curriedTransparentize$1(0.65, equitableBaseColors.neutral["700"])
      // 35% opacity of default text color
    }
  },
  iconInteraction: {
    disabled: equitableBaseColors.neutral["600"],
    action: {
      default: equitableBaseColors.blue["600"],
      hover: equitableBaseColors.blue["800"],
      pressed: equitableBaseColors.blue["900"]
    },
    onColor: {
      default: equitableBaseColors.neutral["0"],
      hover: curriedTransparentize$1(0.2, equitableBaseColors.neutral["0"]),
      // 80% opacity
      pressed: curriedTransparentize$1(0.1, equitableBaseColors.neutral["0"])
      // 90% opacity
    },
    destructive: {
      default: "#8D140E",
      hover: "#CB1D15",
      pressed: "#A21711"
    }
  },
  chart: {
    line: {
      L1: "#278904",
      L2: "#CC1AD4"
    },
    bar: {
      B1: "#4695D4",
      B2: "#38179E",
      B3: "#4695D4",
      B4: "#278904",
      B5: "#BA1C21"
    },
    area: {
      A1: "#38179E",
      A1Fill: "#5E65FB20"
    },
    pie: {
      P1: "#278904",
      P2: "#38179E",
      P3: "#4695D4"
    }
  }
};
const equitableTokens = extendsType()(merge({}, BASE_TOKENS, {
  colors: {
    ...equitableBaseColors,
    ...equitableEnterpriseColors
  },
  fonts: {
    fontsToLoad: [FontLoaderFonts.Caveat, FontLoaderFonts.GTAmerica]
  }
}));
const typographyGroupsOverrides$1 = extendsType()({
  headlineProps: {
    fontFamily: "GT America Extended, sans-serif",
    fontWeight: equitableTokens.fonts.weights.medium,
    // 500
    color: equitableTokens.colors.text.headline
  },
  headerProps: {
    fontFamily: "GT America, sans-serif",
    fontWeight: equitableTokens.fonts.weights.medium,
    // 500
    letterSpacing: "0em"
  },
  bodyProps: {
    fontWeight: equitableTokens.fonts.weights.normal,
    // 400
    fontFamily: "GT America, sans-serif",
    letterSpacing: "0em",
    lineHeight: equitableTokens.fonts.lineHeights["140%"]
  },
  labelProps: {
    fontFamily: "GT America, sans-serif",
    letterSpacing: equitableTokens.fonts.letterSpacing["12%"],
    lineHeight: equitableTokens.fonts.lineHeights["140%"],
    fontWeight: equitableTokens.fonts.weights.normal,
    // 400
    textTransform: "uppercase"
  },
  signatureProps: {
    fontFamily: "Caveat, ui-sans-serif"
  },
  numericTextProps: {
    fontFamily: "GT America, sans-serif"
  },
  disclaimerProps: {
    fontFamily: "GT America Condensed, sans-serif",
    fontWeight: equitableTokens.fonts.weights.normal,
    // 400
    letterSpacing: "0rem"
  },
  hyperlinkProps: {
    fontFamily: "GT America, sans-serif",
    fontWeight: equitableTokens.fonts.weights.normal
    // 400
  }
});
const COLOR_TEXT_HEADLINE$2 = "#002677";
const COLOR_TEXT_DEFAULT$2 = "#333333";
const COLOR_TEXT_SUBDUED$2 = "#6F7276";
const equitableTypography = merge({}, buildTypographyVariants(typographyGroupsOverrides$1)(equitableTokens), {
  headline: {
    fontFamily: "GT America Extended, sans-serif",
    fontWeight: "500",
    color: COLOR_TEXT_HEADLINE$2,
    letterSpacing: "-0.01em",
    lineHeight: "125%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: "GT America, sans-serif",
    fontWeight: "500",
    color: COLOR_TEXT_DEFAULT$2,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: "GT America, sans-serif",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$2,
    colorSubdued: COLOR_TEXT_SUBDUED$2,
    lineHeight: "140%",
    uppercase: true,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: "GT America, sans-serif",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$2,
    colorSubdued: COLOR_TEXT_SUBDUED$2,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT$2,
    fontFamily: "GT America Condensed, sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat, ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  },
  variants: {
    headlineLarge: {
      desktop: {
        lineHeight: "110%"
      },
      tablet: {
        lineHeight: "110%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headlineMedium: {
      desktop: {
        lineHeight: "125%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headlineSmall: {
      desktop: {
        lineHeight: "125%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    // todo - test that the font family overrides typo group properly
    // first, deploy the font family def changes to infra repo
    headerXLarge: {
      desktop: {
        color: equitableTokens.colors.text.headline,
        fontFamily: "GT America Extended, sans-serif",
        lineHeight: "120%"
      },
      tablet: {
        color: equitableTokens.colors.text.headline,
        fontFamily: "GT America Extended, sans-serif",
        lineHeight: "120%"
      },
      mobile: {
        color: equitableTokens.colors.text.headline,
        fontFamily: "GT America Extended, sans-serif",
        lineHeight: "120%"
      }
    },
    headerLarge: {
      desktop: {
        lineHeight: "120%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headerMedium: {
      desktop: {
        lineHeight: "130%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headerSmall: {
      desktop: {
        lineHeight: "140%"
      },
      mobile: {
        lineHeight: "140%"
      }
    },
    headerXSmall: {
      desktop: {
        lineHeight: "140%"
      },
      mobile: {
        lineHeight: "140%"
      }
    },
    bodyXLarge: {
      desktop: {
        lineHeight: "160%"
      }
    },
    bodyLarge: {
      desktop: {
        lineHeight: "150%"
      },
      tablet: {
        lineHeight: "150%"
      }
    },
    bodyMedium: {
      desktop: {
        lineHeight: "160%"
      },
      tablet: {
        lineHeight: "160%"
      }
    }
  }
});
const equitableComponentStyles = {
  buttons: {
    variants: {
      primary: {
        boxShadow: "none",
        borderRadius: "2px"
      },
      destructivePrimary: {
        boxShadow: "none",
        borderRadius: "2px"
      },
      destructiveSecondary: {
        boxShadow: "none",
        borderRadius: "2px"
      },
      outline: {
        boxShadow: "none",
        borderRadius: "2px"
      }
    },
    sizes: {}
  },
  banners: {
    borderRadius: "2px"
  },
  badges: {
    borderRadius: "2px",
    sizes: {
      compact: {
        borderRadius: "1px"
      }
    }
  },
  card: {
    borderRadius: "2px",
    boxShadow: "none"
  },
  highlightedCheckbox: {
    background: {
      default: equitableBaseColors.blue["50"],
      hover: equitableBaseColors.blue["200"],
      disabled: equitableBaseColors.neutral["100"],
      invalid: equitableEnterpriseColors.status.critical.light
    },
    background_image_color: {
      default: equitableBaseColors.blue["600"],
      hover: equitableBaseColors.blue["800"],
      disabled: equitableBaseColors.neutral["400"],
      invalid: equitableEnterpriseColors.status.critical.default
    },
    outline: {
      focus: equitableEnterpriseColors.focus
    },
    textColor: {
      disabled: equitableBaseColors.neutral["600"]
    }
  },
  inputs: {
    borderRadius: "2px",
    allCaps: false
  },
  links: {
    variants: {
      auto: {
        color: equitableEnterpriseColors.links.onColor.default,
        fill: equitableEnterpriseColors.links.onColor.default,
        hoverStyle: {
          color: equitableEnterpriseColors.links.onColor.hover
        },
        activeStyle: {
          color: equitableEnterpriseColors.links.onColor.pressed
        }
      }
    }
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/equitable-onLight.svg", "Equitable"),
        logoMark: getStaticAssetUrl("/Logos/equitable-logomark-onLight.svg", "Equitable")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/equitable-onDark.svg", "Equitable"),
        logoMark: getStaticAssetUrl("/Logos/equitable-logomark-onDark.svg", "Equitable")
      },
      auto: "onDark"
    }
  },
  signature: {
    background: {
      default: equitableBaseColors.blue["50"],
      hover: equitableBaseColors.blue["200"],
      disabled: equitableBaseColors.neutral["100"]
    },
    borderColor: {
      default: equitableBaseColors.blue["600"],
      hover: equitableBaseColors.neutral["800"],
      disabled: "#BBBBBB"
    },
    textColor: {
      disabled: equitableBaseColors.neutral["700"]
    }
  }
};
const EQUITABLE_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(equitableTokens, equitableTypography),
  // The "as const" here allows TS to view this type as "Equitable Theme" instead of just "string"
  name: "Equitable Theme",
  key: "EQUITABLE_THEME"
}, equitableComponentStyles));
const errorColor = "#DB3814";
const BASE_COLOR_SCALES = {
  neutral: {
    0: "#FFFFFF",
    50: "#FAFAFA",
    100: "#F8F8F8",
    200: "#F3F3F3",
    300: "#E8E8E8",
    400: "#D1D1D1",
    500: "#BBBBBB",
    600: "#9B9B9B",
    700: "#6E6E6E",
    800: "#464646",
    900: "#222222"
  },
  red: {
    50: "#FFF5F0",
    100: "#FFE9DE",
    150: "#FFD4C8",
    // Added 150 key
    200: "#FFCBB6",
    300: "#FFAB8C",
    400: "#F78460",
    500: "#EA5A36",
    600: "#C43E23",
    700: "#9E2715",
    800: "#78150A",
    900: "#520B06"
  },
  green: {
    50: "#E6FFEC",
    100: "#A3FF8D",
    200: "#77F79F",
    300: "#4BEB83",
    400: "#23DE6B",
    500: "#00D158",
    600: "#00AB4D",
    700: "#008540",
    800: "#005E31",
    900: "#00381F"
  },
  yellow: {
    50: "#FFFAE6",
    100: "#FFFAD1",
    150: "#FFF5E5",
    // Added 150 key
    200: "#FFF3A8",
    300: "#FFEA80",
    400: "#FFCF2F",
    500: "#FE9F00",
    600: "#D98200",
    700: "#B36500",
    800: "#8C4B00",
    900: "#663300"
  },
  blue: {
    50: "#F0FEFF",
    100: "#E3FDFF",
    200: "#BAF8FF",
    300: "#8AE4F2",
    400: "#5ECFE6",
    500: "#37B9D9",
    600: "#2491B3",
    700: "#00547A",
    800: "#052F5F",
    900: "#062C40"
  }
};
const lanternBaseColors = {
  ...BASE_COLOR_SCALES,
  someBrandedColors: {}
};
const lanternEnterpriseColors = {
  brand: {},
  text: {
    headline: BASE_COLOR_SCALES.blue[900],
    default: BASE_COLOR_SCALES.neutral[900],
    subdued: BASE_COLOR_SCALES.neutral[700],
    onColor: BASE_COLOR_SCALES.neutral[0]
  },
  avatars: [{
    backgroundColor: lanternBaseColors.blue[800],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.blue[500],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.red[500],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.green[500],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.blue[700],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.yellow[500],
    color: lanternBaseColors.neutral[900]
  }, {
    backgroundColor: lanternBaseColors.green[800],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.blue[300],
    color: lanternBaseColors.neutral[900]
  }, {
    backgroundColor: lanternBaseColors.blue[100],
    color: lanternBaseColors.neutral[900]
  }, {
    backgroundColor: lanternBaseColors.green[700],
    color: lanternBaseColors.neutral[0]
  }, {
    backgroundColor: lanternBaseColors.green[300],
    color: lanternBaseColors.neutral[900]
  }, {
    backgroundColor: lanternBaseColors.green[100],
    color: lanternBaseColors.neutral[900]
  }, {
    backgroundColor: lanternBaseColors.red[300],
    color: lanternBaseColors.neutral[900]
  }, {
    backgroundColor: lanternBaseColors.yellow[300],
    color: lanternBaseColors.neutral[900]
  }],
  background: {
    default: lanternBaseColors.neutral[0],
    surface100: lanternBaseColors.neutral[50],
    surface200: lanternBaseColors.neutral[200],
    brand: lanternBaseColors.blue[800],
    accentConsumer: lanternBaseColors.blue[700],
    accentEnterprise: lanternBaseColors.blue[700],
    informative: {
      default: lanternBaseColors.blue[700],
      light: lanternBaseColors.blue[50]
    },
    tooltip: lanternBaseColors.blue[900]
  },
  navigation: {
    backgroundAuto: lanternBaseColors.blue[800],
    borderAuto: lanternBaseColors.blue[800],
    textAuto: lanternBaseColors.neutral[0]
  },
  border: {
    default: lanternBaseColors.neutral[400],
    brand: lanternBaseColors.blue[700],
    onColor: "rgba(255,255,255,0.2)",
    destructive: errorColor
  },
  icon: {
    default: lanternBaseColors.neutral[900],
    subdued: lanternBaseColors.neutral[700],
    onColor: lanternBaseColors.neutral[0],
    brand: lanternBaseColors.blue[700]
  },
  status: {
    success: {
      default: lanternBaseColors.green[700],
      light: lanternBaseColors.green[50],
      dark: lanternBaseColors.green[900]
    },
    warning: {
      default: lanternBaseColors.yellow[400],
      light: lanternBaseColors.yellow[100],
      dark: lanternBaseColors.yellow[800]
    },
    critical: {
      default: errorColor,
      light: lanternBaseColors.red[50],
      dark: lanternBaseColors.red[800]
    }
  },
  focus: lanternBaseColors.blue[600],
  buttons: {
    primary: {
      fill: {
        default: lanternBaseColors.blue[400],
        hover: lanternBaseColors.blue[300],
        pressed: lanternBaseColors.blue[200],
        disabled: lanternBaseColors.neutral[300]
      },
      text: {
        default: lanternBaseColors.neutral[900],
        disabled: lanternBaseColors.neutral[500]
      },
      border: {
        focus: lanternBaseColors.blue[600]
      }
    },
    secondary: {
      fill: {
        default: "transparent",
        hover: lanternBaseColors.blue[50],
        pressed: lanternBaseColors.blue[100],
        disabled: "transparent"
      },
      text: {
        default: lanternBaseColors.blue[700],
        disabled: lanternBaseColors.neutral[500]
      },
      border: {
        default: lanternBaseColors.blue[700],
        hover: lanternBaseColors.blue[800],
        disabled: lanternBaseColors.neutral[500],
        focus: lanternBaseColors.blue[700]
      }
    },
    ghost: {
      focus: lanternBaseColors.blue[600],
      fill: {
        default: "transparent",
        hover: lanternBaseColors.blue[50],
        pressed: lanternBaseColors.blue[100],
        disabled: lanternBaseColors.neutral[300]
      },
      text: {
        default: lanternBaseColors.blue[700],
        disabled: lanternBaseColors.neutral[500]
      }
    },
    destructive: {
      focus: "#B71A13",
      primary: {
        fill: {
          default: errorColor,
          hover: lanternBaseColors.red[700],
          pressed: lanternBaseColors.red[800],
          disabled: lanternBaseColors.neutral[300]
        },
        text: {
          default: lanternBaseColors.neutral[0],
          disabled: lanternBaseColors.neutral[500]
        }
      },
      secondary: {
        focus: lanternBaseColors.red[700],
        fill: {
          default: "transparent",
          hover: lanternBaseColors.red[100],
          pressed: lanternBaseColors.red[200],
          disabled: lanternBaseColors.neutral[300]
        },
        text: {
          default: lanternBaseColors.red[700],
          disabled: lanternBaseColors.neutral[500]
        },
        border: {
          default: lanternBaseColors.red[700],
          disabled: "#DADBDC"
        }
      },
      ghost: {
        focus: lanternBaseColors.red[700],
        fill: {
          default: "transparent",
          hover: lanternBaseColors.red[100],
          pressed: lanternBaseColors.red[200],
          disabled: lanternBaseColors.neutral[300]
        },
        text: {
          default: lanternBaseColors.red[700],
          disabled: lanternBaseColors.neutral[500]
        }
      }
    }
  },
  links: {
    disabled: lanternBaseColors.neutral[500],
    action: {
      default: lanternBaseColors.blue[700],
      hover: lanternBaseColors.blue[800],
      pressed: lanternBaseColors.blue[900]
    },
    destructive: {
      default: errorColor,
      hover: lanternBaseColors.red[700],
      pressed: lanternBaseColors.red[800]
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: lanternBaseColors.neutral[0],
      hover: lanternBaseColors.neutral[100],
      pressed: lanternBaseColors.neutral[300],
      selected: lanternBaseColors.blue[300],
      selectedHover: lanternBaseColors.blue[400],
      disabled: lanternBaseColors.neutral[300],
      activated: lanternBaseColors.blue[300]
    },
    border: {
      default: lanternBaseColors.neutral[500],
      hover: lanternBaseColors.neutral[600],
      pressed: lanternBaseColors.neutral[700],
      selected: lanternBaseColors.blue[600]
    },
    text: {
      default: lanternBaseColors.neutral[900],
      selected: lanternBaseColors.neutral[900],
      disabled: lanternBaseColors.neutral[500],
      hint: lanternBaseColors.neutral[500]
    }
  },
  iconInteraction: {
    disabled: lanternBaseColors.neutral[500],
    action: {
      default: lanternBaseColors.blue[700],
      hover: lanternBaseColors.blue[800],
      pressed: lanternBaseColors.blue[900]
    },
    onColor: {
      default: lanternBaseColors.neutral[0],
      hover: "transparent",
      pressed: "transparent"
    },
    destructive: {
      default: errorColor,
      hover: lanternBaseColors.red[700],
      pressed: lanternBaseColors.red[800]
    }
  },
  chart: {
    line: {
      L1: "#278904",
      L2: "#CC1AD4"
    },
    bar: {
      B1: "#4695D4",
      B2: "#38179E",
      B3: "#4695D4",
      B4: "#278904",
      B5: "#BA1C21"
    },
    area: {
      A1: "#38179E",
      A1Fill: "#5E65FB20"
    },
    pie: {
      P1: "#278904",
      P2: "#38179E",
      P3: "#4695D4"
    }
  }
};
const lanternColors = extendsType()(merge({}, lanternBaseColors, lanternEnterpriseColors));
const lanternTypographyGroupsOverrides = extendsType()({
  headlineProps: {
    fontFamily: "Perfectly Nineties, sans-serif",
    fontWeight: "600",
    color: lanternColors.text.headline,
    lineHeight: "110%",
    fontSmoothing: "antialiased"
  },
  headerProps: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "400",
    lineHeight: "120%",
    fontSmoothing: "antialiased"
  },
  bodyProps: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "300",
    lineHeight: "160%",
    fontSmoothing: "antialiased"
  },
  labelProps: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "400",
    letterSpacing: "1.68px",
    fontSmoothing: "antialiased",
    textTransform: "uppercase"
  },
  signatureProps: {
    fontFamily: "Caveat, ui-sans-serif",
    variants: {
      desktop: {
        fontSize: BASE_FONTS.sizes[32]
      }
    },
    fontSmoothing: "antialiased"
  },
  numericTextProps: {
    fontFamily: "Open Sans, sans-serif",
    fontSmoothing: "antialiased"
  },
  hyperlinkProps: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "300",
    fontSmoothing: "antialiased",
    lineHeight: "130%"
  },
  disclaimerProps: {
    fontFamily: "Open Sans Condensed, sans-serif",
    fontWeight: "400",
    letterSpacing: "0rem",
    fontSmoothing: "antialiased"
  }
});
const lanternTokens = extendsType()({
  ...BASE_TOKENS,
  colors: lanternColors,
  fonts: {
    ...BASE_FONTS,
    fontsToLoad: [FontLoaderFonts.Caveat, FontLoaderFonts.OpenSansCondensed, FontLoaderFonts.PerfectlyNineties, FontLoaderFonts["Open Sans"], FontLoaderFonts.GTAmerica]
  }
});
const COLOR_TEXT_HEADLINE$1 = "#062C40";
const COLOR_TEXT_DEFAULT$1 = "#101828";
const COLOR_TEXT_SUBDUED$1 = "#344054";
const lanternTypography = merge({}, buildTypographyVariants(lanternTypographyGroupsOverrides)(lanternTokens), {
  headline: {
    fontFamily: "Perfectly Nineties, sans-serif",
    fontWeight: "600",
    color: COLOR_TEXT_HEADLINE$1,
    letterSpacing: "-0.02em",
    lineHeight: "110%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$1,
    lineHeight: "120%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT$1,
    colorSubdued: COLOR_TEXT_SUBDUED$1,
    lineHeight: "160%",
    uppercase: true,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "300",
    color: COLOR_TEXT_DEFAULT$1,
    colorSubdued: COLOR_TEXT_SUBDUED$1,
    lineHeight: "160%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT$1,
    fontFamily: "Open Sans Condensed, sans-serif",
    fontWeight: "400",
    lineHeight: "150%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat, ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  }
});
const lanternComponentStyles = {
  card: {
    borderRadius: "4px"
  },
  inputs: {
    fontFamily: "Open Sans, sans-serif",
    borderRadius: "6px",
    fontWeight: "300",
    labelStyles: {
      fontWeight: "300"
    }
  },
  links: {
    variants: {
      auto: {
        color: lanternColors.links.onColor.default,
        fill: lanternColors.links.onColor.default,
        hoverStyle: {
          color: lanternColors.links.onColor.hover
        },
        activeStyle: {
          color: lanternColors.links.onColor.pressed
        }
      }
    }
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/lantern-onLight.svg", "Lantern"),
        logoMark: getStaticAssetUrl("/Logos/lantern-logomark-onLight.svg", "Lantern")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/lantern-onDark.svg", "Lantern"),
        logoMark: getStaticAssetUrl("/Logos/lantern-logomark-onDark.svg", "Lantern")
      },
      auto: "onDark"
    }
  },
  popovers: {
    fontFamily: "Open Sans, sans-serif",
    variants: {
      tooltip: {
        background: lanternEnterpriseColors.background.tooltip
      }
    }
  },
  divider: {
    variants: {
      default: {
        bg: lanternEnterpriseColors.forms.text.disabled
      }
    }
  },
  badges: {
    borderRadius: "4px",
    sizes: {
      compact: {
        borderRadius: "2px"
      }
    }
  },
  banners: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "300",
    borderRadius: "4px",
    variants: {
      informational: {
        bg: lanternEnterpriseColors.background.informative.default,
        color: BASE_COLOR_SCALES.neutral[0]
      },
      informationalWeak: {
        bg: lanternEnterpriseColors.background.informative.light
      },
      warning: {
        bg: lanternEnterpriseColors.status.warning.default
      },
      warningWeak: {
        bg: lanternEnterpriseColors.status.warning.light
      },
      error: {
        bg: lanternEnterpriseColors.status.critical.default,
        color: BASE_COLOR_SCALES.neutral[0]
      },
      errorWeak: {
        bg: lanternEnterpriseColors.status.critical.light
      },
      success: {
        bg: lanternEnterpriseColors.status.success.default,
        color: BASE_COLOR_SCALES.neutral[0]
      },
      successWeak: {
        bg: lanternEnterpriseColors.status.success.light
      }
    }
  },
  signature: {
    background: {
      default: lanternBaseColors.blue[50],
      hover: lanternBaseColors.blue[100],
      disabled: "#E8E8E8"
    },
    borderColor: {
      default: lanternBaseColors.blue[800],
      hover: "#1F355E",
      disabled: "#DADBDC"
    },
    textColor: {
      disabled: "#474B4E"
    }
  },
  highlightedCheckbox: {
    background: {
      default: lanternBaseColors.blue[50],
      hover: lanternBaseColors.blue[100],
      disabled: lanternBaseColors.neutral[300],
      invalid: lanternBaseColors.red[50]
    },
    background_image_color: {
      default: lanternBaseColors.blue[700],
      hover: lanternBaseColors.blue[700],
      disabled: lanternBaseColors.neutral[600],
      invalid: errorColor
    },
    outline: {
      focus: lanternEnterpriseColors.focus
    },
    textColor: {
      disabled: lanternBaseColors.neutral[500]
    }
  },
  sliderInput: {
    disabledColor: lanternBaseColors.neutral[300],
    inactiveColor: lanternBaseColors.neutral[300]
  },
  toasts: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "300"
  }
};
const LANTERN_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(lanternTokens, lanternTypography),
  name: "Lantern Theme",
  key: "LANTERN_THEME"
}, lanternComponentStyles));
const enterpriseBlue = {
  25: "#F5F9FF",
  50: "#EBF4FF",
  100: "#DEEDFF",
  200: "#C3D4FF",
  300: "#9FB2FF",
  400: "#7988FF",
  500: "#5E65FB",
  600: "#444CE7",
  700: "#3538CD",
  800: "#2D31A6",
  900: "#2D3282"
};
const enterpriseNeutral = {
  0: "#FFFFFF",
  50: "#F9FAFB",
  100: "#F2F4F7",
  200: "#E4E7EC",
  300: "#C4C9D2",
  400: "#A5ABB8",
  500: "#858D9E",
  600: "#667085",
  700: "#475467",
  800: "#344054",
  900: "#101828"
};
const enterpriseRed = {
  50: "#FFF2F1",
  100: "#FFE3E1",
  150: "#FAC4C0",
  200: "#FAC4C0",
  300: "#FB948E",
  400: "#F96C64",
  500: "#F8453B",
  600: "#E5271D",
  700: "#BB1B13",
  800: "#921009",
  900: "#690500"
};
const enterpriseGreen = {
  50: "#EBFEF6",
  100: "#CFFCE7",
  200: "#B0F7DC",
  300: "#7FE9C5",
  400: "#4BD6AB",
  500: "#09C08A",
  600: "#009C71",
  700: "#008460",
  800: "#006D4F",
  900: "#00563E"
};
const enterpriseYellow = {
  50: "#FFFBEB",
  100: "#FFF5C6",
  150: "#FDE096",
  200: "#FDE096",
  300: "#FCCB66",
  400: "#FAB636",
  500: "#F9A207",
  600: "#DD7A02",
  700: "#B76401",
  800: "#914F00",
  900: "#6B3A00"
};
const enterpriseMagenta = {
  25: "#FEFAFF",
  50: "#FDF4FF",
  100: "#FBE8FF",
  200: "#F6D0FE",
  300: "#EEAAFD",
  400: "#E478FA",
  500: "#D444F1",
  600: "#BA24D5",
  700: "#9F1AB1",
  800: "#821890",
  900: "#6F1877",
  950: "#47104C"
};
const enterpriseOrange = {
  25: "#FFF9F5",
  50: "#FFF4ED",
  100: "#FFE6D5",
  200: "#FFD6AE",
  300: "#FF9C66",
  400: "#FF692E",
  500: "#FF4405",
  600: "#E62E05",
  700: "#BC1B06",
  800: "#97180C",
  900: "#771A0D",
  950: "#57130A"
};
const baseColors = merge({}, BASE_COLOR_SCALES$5, {
  blue: enterpriseBlue,
  neutral: enterpriseNeutral,
  red: enterpriseRed,
  green: enterpriseGreen,
  yellow: enterpriseYellow,
  magenta: enterpriseMagenta,
  orange: enterpriseOrange,
  bone: "#F8F4F2",
  charcoal: enterpriseNeutral["900"]
});
const bestowEnterpriseColors = {
  brand: enterpriseBlue,
  text: {
    headline: enterpriseNeutral["900"],
    default: enterpriseNeutral["800"],
    subdued: enterpriseNeutral["600"],
    onColor: enterpriseNeutral["0"]
  },
  avatars: [{
    backgroundColor: enterpriseBlue[500],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseBlue[700],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseBlue[800],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseNeutral[600],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseNeutral[800],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseGreen[600],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseGreen[800],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseYellow[500],
    color: enterpriseNeutral[800]
  }, {
    backgroundColor: enterpriseMagenta[700],
    color: enterpriseNeutral[0]
  }, {
    backgroundColor: enterpriseBlue[100],
    color: enterpriseNeutral[800]
  }, {
    backgroundColor: enterpriseNeutral[200],
    color: enterpriseNeutral[800]
  }, {
    backgroundColor: enterpriseGreen[200],
    color: enterpriseNeutral[800]
  }, {
    backgroundColor: enterpriseYellow[100],
    color: enterpriseNeutral[800]
  }, {
    backgroundColor: enterpriseMagenta[200],
    color: enterpriseNeutral[800]
  }],
  background: {
    default: enterpriseNeutral["0"],
    surface100: enterpriseNeutral["50"],
    surface200: enterpriseNeutral["100"],
    brand: enterpriseNeutral["900"],
    accentConsumer: enterpriseBlue["500"],
    accentEnterprise: enterpriseBlue["500"],
    informative: {
      default: enterpriseBlue["500"],
      light: enterpriseBlue["50"]
    },
    tooltip: enterpriseNeutral["900"]
  },
  navigation: {
    backgroundAuto: enterpriseNeutral["0"],
    borderAuto: "#E5E7EB",
    textAuto: enterpriseNeutral["900"]
  },
  border: {
    default: enterpriseNeutral["200"],
    brand: enterpriseBlue["500"],
    onColor: "rgba(255, 255, 255, 0.2)",
    destructive: enterpriseRed["600"]
  },
  icon: {
    default: enterpriseNeutral["900"],
    subdued: enterpriseNeutral["600"],
    onColor: enterpriseNeutral["0"],
    brand: enterpriseBlue["500"]
  },
  status: {
    success: {
      default: enterpriseGreen["600"],
      light: enterpriseGreen["50"],
      dark: enterpriseGreen["900"]
    },
    critical: {
      default: enterpriseRed["600"],
      light: enterpriseRed["50"],
      dark: enterpriseRed["800"]
    },
    warning: {
      default: enterpriseYellow["400"],
      light: enterpriseYellow["100"],
      dark: enterpriseYellow["800"]
    }
  },
  focus: enterpriseBlue["500"],
  buttons: {
    primary: {
      fill: {
        default: enterpriseBlue["500"],
        hover: enterpriseBlue["700"],
        pressed: enterpriseBlue["800"],
        disabled: enterpriseNeutral["200"]
      },
      text: {
        default: enterpriseNeutral["0"],
        disabled: enterpriseNeutral["600"]
      }
    },
    secondary: {
      fill: {
        default: enterpriseBlue["100"],
        hover: enterpriseBlue["200"],
        pressed: enterpriseBlue["300"],
        disabled: enterpriseNeutral["200"]
      },
      text: {
        default: enterpriseBlue["600"],
        disabled: enterpriseNeutral["600"]
      },
      border: {
        default: enterpriseBlue["100"],
        hover: enterpriseBlue["200"],
        disabled: enterpriseNeutral["200"]
      }
    },
    ghost: {
      focus: enterpriseBlue["500"],
      fill: {
        default: "transparent",
        hover: enterpriseBlue["50"],
        pressed: enterpriseBlue["100"],
        disabled: "transparent"
      },
      text: {
        default: enterpriseBlue["500"],
        disabled: enterpriseNeutral["600"]
      }
    },
    destructive: {
      focus: enterpriseRed["600"],
      primary: {
        fill: {
          default: enterpriseRed["600"],
          hover: enterpriseRed["700"],
          pressed: enterpriseRed["800"],
          disabled: enterpriseNeutral["200"]
        },
        text: {
          default: enterpriseNeutral["0"],
          disabled: enterpriseNeutral["600"]
        }
      },
      secondary: {
        focus: enterpriseRed["700"],
        fill: {
          default: enterpriseRed["50"],
          hover: enterpriseRed["100"],
          pressed: enterpriseRed["200"],
          disabled: enterpriseNeutral["200"]
        },
        text: {
          default: enterpriseRed["700"],
          disabled: enterpriseNeutral["600"]
        },
        border: {
          default: enterpriseRed["50"],
          disabled: enterpriseNeutral["200"]
        }
      },
      ghost: {
        focus: enterpriseRed["700"],
        fill: {
          default: "transparent",
          hover: enterpriseRed["100"],
          pressed: enterpriseRed["200"],
          disabled: "transparent"
        },
        text: {
          default: enterpriseRed["700"],
          disabled: enterpriseNeutral["600"]
        }
      }
    }
  },
  links: {
    disabled: enterpriseNeutral["500"],
    action: {
      default: enterpriseBlue["500"],
      hover: enterpriseBlue["700"],
      pressed: enterpriseBlue["800"]
    },
    destructive: {
      default: enterpriseRed["600"],
      hover: enterpriseRed["700"],
      pressed: enterpriseRed["800"]
    },
    onColor: {
      default: BASE_TOKENS.linkColors.onColor.default,
      hover: BASE_TOKENS.linkColors.onColor.hover,
      pressed: BASE_TOKENS.linkColors.onColor.pressed
    }
  },
  forms: {
    fill: {
      default: enterpriseNeutral["0"],
      hover: enterpriseNeutral["100"],
      pressed: enterpriseNeutral["300"],
      selected: enterpriseBlue["300"],
      selectedHover: enterpriseBlue["400"],
      activated: enterpriseBlue["300"],
      disabled: enterpriseNeutral["200"]
    },
    border: {
      default: enterpriseNeutral["300"],
      hover: enterpriseNeutral["600"],
      pressed: enterpriseNeutral["700"],
      selected: enterpriseBlue["500"]
    },
    text: {
      default: enterpriseNeutral["800"],
      selected: enterpriseNeutral["800"],
      disabled: enterpriseNeutral["500"],
      hint: enterpriseNeutral["600"]
    }
  },
  iconInteraction: {
    disabled: enterpriseNeutral["500"],
    action: {
      default: enterpriseBlue["500"],
      hover: enterpriseBlue["700"],
      pressed: enterpriseBlue["800"]
    },
    onColor: {
      default: "rgba(255, 255, 255)",
      hover: "rgba(255, 255, 255, 0.8)",
      pressed: "rgba(255, 255, 255, 0.9)"
    },
    destructive: {
      default: enterpriseRed["600"],
      hover: enterpriseRed["700"],
      pressed: enterpriseRed["800"]
    }
  },
  chart: {
    line: {
      L1: enterpriseGreen["600"],
      L2: enterpriseMagenta["700"]
    },
    bar: {
      B1: enterpriseBlue["500"],
      B2: enterpriseNeutral["600"],
      B3: enterpriseGreen["600"],
      B4: enterpriseYellow["500"],
      B5: enterpriseRed["600"]
    },
    area: {
      A1: enterpriseBlue["500"],
      A1Fill: `${enterpriseBlue["500"]}20`
    },
    pie: {
      P1: enterpriseBlue["500"],
      P2: enterpriseGreen["600"],
      P3: enterpriseYellow["500"]
    }
  }
};
const bestowTokens = extendsType()(merge({}, BASE_TOKENS, {
  colors: {
    ...baseColors,
    ...bestowEnterpriseColors
  },
  fonts: {
    ...BASE_FONTS,
    fontsToLoad: [FontLoaderFonts.Caveat, FontLoaderFonts.Figtree]
  }
}));
const backupFonts = 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';
const typographyGroupsOverrides = extendsType()({
  headlineProps: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: bestowTokens.fonts.weights.light,
    // 300 - Light
    color: bestowTokens.colors.text.headline,
    letterSpacing: "-0.02em"
  },
  headerProps: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: bestowTokens.fonts.weights.semibold,
    // 600 - SemiBold
    letterSpacing: "0em"
  },
  bodyProps: {
    fontWeight: bestowTokens.fonts.weights.normal,
    // 400 - Regular
    fontFamily: `Figtree, ${backupFonts}`,
    letterSpacing: "0em",
    lineHeight: bestowTokens.fonts.lineHeights["140%"],
    defaultVariant: "bodyMediumDesktop"
  },
  labelProps: {
    fontFamily: `Figtree, ${backupFonts}`,
    letterSpacing: bestowTokens.fonts.letterSpacing["12%"],
    lineHeight: bestowTokens.fonts.lineHeights["140%"],
    fontWeight: bestowTokens.fonts.weights.semibold,
    // 600 - SemiBold
    textTransform: "uppercase"
  },
  signatureProps: {
    fontFamily: "Caveat"
  },
  numericTextProps: {
    fontFamily: `Figtree, ${backupFonts}`
  },
  hyperlinkProps: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: bestowTokens.fonts.weights.normal
    // 400 - Regular
  },
  disclaimerProps: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: bestowTokens.fonts.weights.normal,
    // 400 - Regular
    letterSpacing: "0rem"
  }
});
const COLOR_TEXT_HEADLINE = "#101828";
const COLOR_TEXT_DEFAULT = "#344054";
const COLOR_TEXT_SUBDUED = "#667085";
const bestowTypography = merge({}, buildTypographyVariants(typographyGroupsOverrides)(bestowTokens), {
  headline: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: "300",
    color: COLOR_TEXT_HEADLINE,
    letterSpacing: "-0.02em",
    lineHeight: "125%",
    large: {
      desktop: {
        fontSize: "4rem"
      },
      tablet: {
        fontSize: "3.5rem"
      },
      mobile: {
        fontSize: "3.25rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "3rem"
      },
      tablet: {
        fontSize: "3rem"
      },
      mobile: {
        fontSize: "2.75rem"
      }
    },
    small: {
      desktop: {
        fontSize: "2.5rem"
      },
      tablet: {
        fontSize: "2.5rem"
      },
      mobile: {
        fontSize: "2.25rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.75rem"
      }
    }
  },
  header: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: "600",
    color: COLOR_TEXT_DEFAULT,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "2rem"
      },
      tablet: {
        fontSize: "2rem"
      },
      mobile: {
        fontSize: "1.375rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    small: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  label: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: "600",
    color: COLOR_TEXT_DEFAULT,
    colorSubdued: COLOR_TEXT_SUBDUED,
    lineHeight: "140%",
    uppercase: true,
    large: {
      desktop: {
        fontSize: "1.125rem"
      },
      tablet: {
        fontSize: "1.125rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  body: {
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: "400",
    color: COLOR_TEXT_DEFAULT,
    colorSubdued: COLOR_TEXT_SUBDUED,
    lineHeight: "140%",
    xLarge: {
      desktop: {
        fontSize: "1.5rem"
      },
      tablet: {
        fontSize: "1.5rem"
      },
      mobile: {
        fontSize: "1.3125rem"
      }
    },
    large: {
      desktop: {
        fontSize: "1.25rem"
      },
      tablet: {
        fontSize: "1.25rem"
      },
      mobile: {
        fontSize: "1.125rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "1rem"
      },
      tablet: {
        fontSize: "1rem"
      },
      mobile: {
        fontSize: "1rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    },
    xSmall: {
      desktop: {
        fontSize: "0.75rem"
      },
      tablet: {
        fontSize: "0.75rem"
      },
      mobile: {
        fontSize: "0.75rem"
      }
    }
  },
  disclaimer: {
    color: COLOR_TEXT_DEFAULT,
    fontFamily: `Figtree, ${backupFonts}`,
    fontWeight: "400",
    lineHeight: "150%",
    xSmall: {
      desktop: {
        fontSize: "0.625rem"
      },
      tablet: {
        fontSize: "0.625rem"
      },
      mobile: {
        fontSize: "0.625rem"
      }
    },
    small: {
      desktop: {
        fontSize: "0.6875rem"
      },
      tablet: {
        fontSize: "0.6875rem"
      },
      mobile: {
        fontSize: "0.6875rem"
      }
    },
    medium: {
      desktop: {
        fontSize: "0.875rem"
      },
      tablet: {
        fontSize: "0.875rem"
      },
      mobile: {
        fontSize: "0.875rem"
      }
    }
  },
  signatureText: {
    fontFamily: "Caveat, ui-sans-serif",
    fontWeight: "400",
    lineHeight: "140%",
    fontSize: "1.5rem"
  },
  variants: {
    headlineLarge: {
      desktop: {
        lineHeight: "120%",
        letterSpacing: "-1.28px"
      },
      mobile: {
        lineHeight: "120%",
        letterSpacing: "-1.28px"
      }
    },
    headlineMedium: {
      desktop: {
        lineHeight: "125%",
        letterSpacing: "-0.96px"
      },
      mobile: {
        lineHeight: "125%",
        letterSpacing: "-0.96px"
      }
    },
    headlineSmall: {
      desktop: {
        lineHeight: "125%",
        letterSpacing: "-0.8px"
      },
      mobile: {
        lineHeight: "125%",
        letterSpacing: "-0.8px"
      }
    },
    headlineXSmall: {
      desktop: {
        lineHeight: "130%",
        letterSpacing: "-0.64px"
      },
      mobile: {
        lineHeight: "130%",
        letterSpacing: "-0.64px"
      }
    },
    headerXLarge: {
      desktop: {
        lineHeight: "120%"
      },
      mobile: {
        lineHeight: "120%"
      }
    },
    headerLarge: {
      desktop: {
        lineHeight: "125%"
      },
      mobile: {
        lineHeight: "125%"
      }
    },
    headerMedium: {
      desktop: {
        lineHeight: "130%"
      },
      mobile: {
        lineHeight: "130%"
      }
    },
    headerSmall: {
      desktop: {
        lineHeight: "140%"
      },
      mobile: {
        lineHeight: "140%"
      }
    },
    headerXSmall: {
      desktop: {
        lineHeight: "140%"
      },
      mobile: {
        lineHeight: "140%"
      }
    }
  }
});
const bestowComponentStyles = {
  spinners: {
    sizes: {
      small: {
        spinnerColor: enterpriseBlue[500]
      },
      medium: {
        spinnerColor: enterpriseBlue[500]
      },
      large: {
        spinnerColor: enterpriseBlue[500]
      }
    }
  },
  sliderInput: {
    thumbStyle: {
      color: bestowTokens.colors.iconInteraction.action.default
    }
  },
  badges: {
    paddingTop: "3px",
    paddingBottom: "3px",
    borderRadius: "6px",
    sizes: {
      compact: {
        borderRadius: "2px"
      }
    }
  },
  banners: {
    borderRadius: "6px"
  },
  buttons: {
    variants: {},
    sizes: {
      large: {
        padding: "11px 40px",
        borderRadius: "100px"
      },
      medium: {
        padding: "9px 24px",
        borderRadius: "100px"
      },
      small: {
        padding: "5px 16px",
        borderRadius: "100px"
      }
    }
  },
  highlightedCheckbox: {
    background: {
      default: enterpriseBlue["50"],
      hover: enterpriseBlue["100"],
      disabled: enterpriseNeutral["200"],
      invalid: enterpriseRed["50"]
    },
    background_image_color: {
      default: enterpriseBlue["500"],
      hover: enterpriseBlue["700"],
      disabled: enterpriseNeutral["500"],
      invalid: enterpriseRed["600"]
    },
    outline: {
      focus: enterpriseBlue["500"]
    },
    textColor: {
      disabled: bestowTokens.colors.text.subdued
    }
  },
  inputs: {
    borderRadius: "6px",
    allCaps: false
  },
  links: {
    variants: {
      auto: {
        color: bestowTokens.colors.links.action.default,
        fill: bestowTokens.colors.links.action.default,
        hoverStyle: {
          color: bestowTokens.colors.links.action.hover
        },
        activeStyle: {
          color: bestowTokens.colors.links.action.pressed
        }
      }
    }
  },
  logos: {
    variants: {
      onLight: {
        logo: getStaticAssetUrl("/Logos/bestow-onLight.svg", "Bestow"),
        logoMark: getStaticAssetUrl("/Logos/bestow-icon-onLight.svg", "Bestow")
      },
      onDark: {
        logo: getStaticAssetUrl("/Logos/bestow-onDark.svg", "Bestow"),
        logoMark: getStaticAssetUrl("/Logos/bestow-icon-onDark.svg", "Bestow")
      },
      auto: "onLight"
    }
  },
  popovers: {
    variants: {
      tooltip: {
        background: bestowEnterpriseColors.background.tooltip
      }
    }
  },
  signature: {
    background: {
      default: enterpriseBlue["50"],
      hover: enterpriseBlue["100"],
      disabled: enterpriseNeutral["200"]
    },
    borderColor: {
      default: enterpriseBlue["500"],
      hover: enterpriseBlue["700"],
      disabled: enterpriseNeutral["400"]
    },
    textColor: {
      disabled: enterpriseNeutral["600"]
    }
  },
  card: {
    borderRadius: "6px"
  }
};
const BESTOW_THEME = checkThemeContract(merge({}, {
  ...buildBaseTheme(bestowTokens, bestowTypography),
  name: "Bestow Enterprise Theme",
  key: "BESTOW_THEME"
}, bestowComponentStyles));
export {
  BESTOW_THEME as B,
  EQUITABLE_THEME as E,
  LANTERN_THEME as L,
  NATIONWIDE_THEME as N,
  TRANSAMERICA_THEME as T,
  USAA_THEME as U
};
